<template>
  <v-snackbar
    v-model="snackbar"
    color="#299942"
    :timeout="3000"
    bottom
    right
    width="300px"
  >
    <v-row no-gutters align="center">
      <v-icon size="24px" color="#FAFAFA">mdi-check-circle</v-icon>

      <span
        style="
          color: #fafafa;
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: 14.4px;
          margin: 0px 10px;
        "
      >
        {{ snackbarText }}
      </span>

      <v-row no-gutters justify="end">
        <div class="closeIcon" style="background: #fafafa" />
      </v-row>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    snackbarText: {
      required: true,
    },
  },
  data() {
    return {
      snackbar: true,
    };
  },
  watch: {
    snackbar(newVal) {
      if (!newVal) {
        this.$emit("hidde");
      }
    },
  },
};
</script>
